import { withAppHOC } from "../../hoc";
import {
  StyledPageHeading,
  StyledPageBody,
  StyledContactMapContainer,
  StyledAddressMapContainer,
  StyledContactFormContainer,
  StyledContactPageContainer,
  StyledContactGrid,
  StyledContactAddressContainer,
  StyledGrid,
} from "../../components/Styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faCalculator,
  faEnvelope,
  faMap,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import {
  Form,
  Button,
  Fieldset,
  Label,
  MessageBox,
  TextInput,
  MobileInput,
} from "../../components/FormElements";
import { useState } from "react";

const Contact = () => {
  const [state, setState] = useState({
    isLoading: false,
    apiResponseStatus: "",
    apiResponseMessage: "",
    fullName: "",
    mobileNumber: "",
    subject: "",
    message: "",
  });

  const setStateData = (key, value) => {
    setState((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  return (
    <>
      <StyledPageHeading>
        <h1>Contact Us</h1>
      </StyledPageHeading>

      <StyledPageBody>
        <StyledContactPageContainer>
          <StyledAddressMapContainer>
            <StyledContactMapContainer>
              <iframe
                title="Office Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.0820700361583!2d77.67727647571466!3d12.966600087348297!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae13736333b083%3A0xbd1207fed23da80b!2sCybersify!5e0!3m2!1sen!2sin!4v1748892681838!5m2!1sen!2sin"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </StyledContactMapContainer>
            <StyledContactAddressContainer>
              <StyledContactGrid>
                <FontAwesomeIcon icon={faBuilding} />
                <h2>Company Name</h2>
              </StyledContactGrid>
              <StyledContactGrid>
                <FontAwesomeIcon icon={faMap} />

                <address>
                  140, 6th Main, 7th Cross, Talacauvery Layout, Basavanagar,
                  Bengaluru, Karntaka, India, 560037
                </address>
              </StyledContactGrid>
              <StyledContactGrid>
                <FontAwesomeIcon icon={faPhone} />
                <p>+91 9999999999</p>
              </StyledContactGrid>
              <StyledContactGrid>
                <FontAwesomeIcon icon={faEnvelope} />
                <p>help@fourseasonsfresh.in</p>
              </StyledContactGrid>
              <StyledContactGrid>
                <FontAwesomeIcon icon={faCalculator} />
                <p>GSTIN: YOUR_GST_NUMBER</p>
              </StyledContactGrid>
            </StyledContactAddressContainer>
          </StyledAddressMapContainer>
          <StyledContactFormContainer>
            <Form action="#" method="POST" onSubmit={() => {}}>
              <StyledGrid>
                <Fieldset>
                  <Label required>Full Name</Label>
                  <TextInput
                    value={state.fullName}
                    onChange={(value) => setStateData("fullName", value)}
                    placeholder="Full Name"
                    disabled={state.isLoading}
                  />
                </Fieldset>
                <Fieldset>
                  <Label required>Mobile Number</Label>
                  <MobileInput
                    value={state.mobileNumber}
                    onChange={(value) => setStateData("mobileNumber", value)}
                    placeholder="Mobile Number"
                    disabled={state.isLoading}
                  />
                </Fieldset>
              </StyledGrid>
              <Fieldset>
                <Label required>Subject</Label>
                <MobileInput
                  value={state.subject}
                  onChange={(value) => setStateData("subject", value)}
                  placeholder="Subject"
                  disabled={state.isLoading}
                />
              </Fieldset>
              <Fieldset>
                <Label required>Message</Label>
                <textarea
                  type="textarea"
                  value={state.message}
                  onChange={(value) => setStateData("message", value)}
                  placeholder="Message"
                  disabled={state.isLoading}
                  style={{
                    height: "292px",
                    fontSize: "14px",
                    fontWeight: "normal",
                    color: "#000000",
                    padding: "15px",
                    margin: "0px",
                    border: "1px solid #ebebeb",
                    borderRadius: "5px",
                    width: "calc(100% - 32px)",
                    flex: 2,
                    backgroundColor: "#f9fafb",
                    outline: "0px",
                  }}
                />
              </Fieldset>
              {state.apiResponseStatus && state.apiResponseMessage && (
                <Fieldset>
                  <MessageBox
                    status={state.apiResponseStatus}
                    message={state.apiResponseMessage}
                  />
                </Fieldset>
              )}
              <Fieldset>
                <Button disabled={state.isLoading}>Send</Button>
              </Fieldset>
            </Form>
          </StyledContactFormContainer>
        </StyledContactPageContainer>
      </StyledPageBody>
    </>
  );
};

export default withAppHOC(Contact);
